/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Vuex from "vuex";
import VueFirestore from "vue-firestore";

// Store functionality
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { db, st, auth } from "./firebase";

// Store modules
import user from "./modules/user";
import snackbar from "./modules/snackbar";
import loading from "./modules/loading";

Vue.use(Vuex);
Vue.use(VueFirestore);

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules: {
    user: user,
    snackbar: snackbar,
    loading: loading
  },
  mutations,
  state: {
    ...state,
    db: db,
    st: st,
    auth: auth
  }
});

export default store;
